module.exports = __webpack_public_path__ + "img/our-space-logo-large.51e0eef5.svg";